import React from 'react';
import Projects from './components/Projects';
import {  BrowserRouter as Router, Routes, Route } from "react-router-dom"
import App from './App';

function Main () {
    
    return (
     <>
     <Router>
      <Routes>
      <Route path="/" element={< App/>}/>
      <Route path="/Projects" element={< Projects/>}/>
      </Routes></Router>
     </>
    );
  };
  
  export default Main;